import React, { Component } from "react";
import Circles from "./circles.jsx";

var SingleMarker = ({ index, title }) => (
  <div className={"marker " + Circles[index].icon}>
    <img
      src={
        "/dist/images/frontend-bundle/layout/map/icon-" +
        Circles[index].icon +
        ".png"
      }
      width={Circles[index].size}
      alt={typeof title !== "undefined" ? title : Circles[index].name}
      title={typeof title !== "undefined" ? title : Circles[index].name}
    />
  </div>
);

export default SingleMarker;
